import React from 'react';
import { Table, Row, Col, Select, DatePicker } from 'antd';
import moment from 'moment';

const { Option } = Select;
const { MonthPicker } = DatePicker;

const CurrentAssignments = ({
  clients = [],
  clientDepartments = [],
  assignments = [],
  assignmentsLoading = false,
  assignmentFilters = {},
  handleAssignmentFilterChange = () => {},
  assignmentColumns = []
}) => {
  return (
    <>
      <div style={{ margin: '32px 0 8px 0', fontWeight: 600 }}>Current Assignments</div>
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={4}>
          <Select
            allowClear
            placeholder="Client"
            value={assignmentFilters.client_id}
            onChange={v => handleAssignmentFilterChange('client_id', v)}
            style={{ width: '100%' }}
          >
            {clients.map(c => <Option key={c.id} value={c.id}>{c.name}</Option>)}
          </Select>
        </Col>
        <Col span={4}>
          <Select
            allowClear
            placeholder="Department"
            value={assignmentFilters.client_department_id}
            onChange={v => handleAssignmentFilterChange('client_department_id', v)}
            style={{ width: '100%' }}
          >
            {clientDepartments.map(dep => <Option key={dep.id} value={dep.id}>{dep.name}</Option>)}
          </Select>
        </Col>
        <Col span={4}>
          <Select
            allowClear
            placeholder="Type"
            value={assignmentFilters.employee_type}
            onChange={v => handleAssignmentFilterChange('employee_type', v)}
            style={{ width: '100%' }}
          >
            <Option value="internal">Internal</Option>
            <Option value="subcontractor">Subcontractor</Option>
          </Select>
        </Col>
        <Col span={4}>
          <Select
            allowClear
            placeholder="Status"
            value={assignmentFilters.status}
            onChange={v => handleAssignmentFilterChange('status', v)}
            style={{ width: '100%' }}
          >
            <Option value="active">Active</Option>
            <Option value="completed">Completed</Option>
          </Select>
        </Col>
        <Col span={4}>
          <MonthPicker
            placeholder="Month"
            value={assignmentFilters.start_date ? moment(assignmentFilters.start_date) : null}
            onChange={d => handleAssignmentFilterChange('start_date', d ? d.startOf('month').format('YYYY-MM-DD') : undefined)}
            style={{ width: '100%' }}
          />
        </Col>
      </Row>
      <Table
        rowKey="id"
        columns={assignmentColumns}
        dataSource={assignments}
        loading={assignmentsLoading}
        pagination={{ pageSize: 10 }}
        bordered
      />
    </>
  );
};

export default CurrentAssignments;
